import React, { Component } from 'react'
import QRcode from 'qrcode.react'
import orderApi from 'services/api/order'
import * as _ from 'lodash'
import styles from '../../assets/styles/components/QrcPayment'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { compose } from 'redux'

class QrcPayment extends Component {
	constructor(props) {
		super(props)
	}

	componentDidMount() {
		if (!this.interval) {
			this.interval = setInterval(() => {
				this.getWechatOrderStatus()
			}, 5 * 1000)
		}
	}
	getWechatOrderStatus = () => {
    const { orderID, submit, handleDisplayQRC, syssn } = this.props
    orderApi.getWechatOrderStatus(orderID).then((result) => {
      if (result.respcd === '0000') {
				submit({ payment: 'wechatpay', source: orderID, syssn: syssn, out_trade_no: orderID })
				handleDisplayQRC()
			}
		})
	}
	componentWillUnmount = () => {
		if (this.interval) clearInterval(this.interval)
	}
	render() {
		const { optionHeading, wechatQRC, classes, intl } = this.props;
		return (
			<div>
				{optionHeading}
				<div className={classes.qrc}>
					<div className={classes.scanText}>
						<span>{intl.formatMessage({ id: 'checkout.method.wechat.scan_to_pay' })}</span>
					</div>
					<QRcode value={wechatQRC} size={200} includeMargin />
					<div className={classes.confirmPayment} onClick={this.getWechatOrderStatus}>
						<span>{intl.formatMessage({ id: 'footer.takeaway.confirm.pay' })}</span>
					</div>
				</div>
			</div>
		)
	}
}

export default compose(injectSheet(styles), injectIntl)(QrcPayment)



// WEBPACK FOOTER //
// ./src/components/wechatpay/QrcPayment.js